<template>
  <div class="header-wrapper">
    <div class="header-row">
      <div class="company-info">
        <h2 v-if="!isLoading">{{ title }}</h2>
        <free-style-shimmer
            :is-loading="isLoading"
            height="20px"
            width="250px"
            border-radius="50px"
            color="#dedede"
        />

        <div class="company-status" v-if="!isLoading">
          <img src="@/assets/images/active.svg" v-if="status && journeyStatus !== 4" />
          <img src="@/assets/images/failed.svg" v-else />
          <span v-if="journeyStatus === 4">{{$t('ended_by_admin')}}</span>
          <span v-else-if="status">{{$t('active')}}</span>
          <span v-else>{{$t('inactive')}}</span>
        </div>

        <free-style-shimmer
            :is-loading="isLoading"
            height="10px"
            width="100px"
            border-radius="50px"
            color="#dedede"
        />
      </div>

      <div class="action-row">

        <button class="action-button" @click="clickNotification" v-click-outside="closeNotification">
          <img src="@/assets/images/notificationOutline.svg" />
          <span>{{$t('send_notifiaction')}}</span>
          <div class="dropdown-wrapper" v-if="this.notificationSelectBoxOpen">
            <div class="dropdown-list" v-for="notification in notificationList" :key="notification.notificationId" @click="assignNotification(notification.notificationId)">
              <span>{{notification.content?.label ||notification.label}}</span>
            </div>
          </div>
        </button>

        <free-style-shimmer
            :is-loading="isLoading"
            height="35px"
            width="140px"
            border-radius="50px"
            color="#dedede"
        />

        <button v-if="!isLoading" class="action-button" @click="onEndJourney">
          <img src="@/assets/images/blockOutline.svg" />
          <span>{{$t('end_the_journey')}}</span>
        </button>

        <free-style-shimmer
            :is-loading="isLoading"
            height="35px"
            width="140px"
            border-radius="50px"
            color="#dedede"
        />
      </div>
    </div>
    <div class="company-stats">
      <div class="stat-wrapper">
        <img src="@/assets/images/program.svg" />
        <span v-if="!isLoading">
          {{ programName }}
        </span>

        <free-style-shimmer
            :is-loading="isLoading"
            height="8px"
            width="80px"
            border-radius="50px"
            color="#dedede"
        />
      </div>

      <div class="stat-wrapper">
        <img src="@/assets/images/datepicker.svg" />
        <span v-if="!isLoading">
          {{$t('created_on')}} {{ formatDate(createdAt) }}
        </span>

        <free-style-shimmer
            :is-loading="isLoading"
            height="8px"
            width="80px"
            border-radius="50px"
            color="#dedede"
        />
      </div>
    </div>

    <img :src="photo" class="company-image" v-if="!isLoading && photo !== null"/>
    <free-style-shimmer
        class="company-image"
        :is-loading="isLoading"
        height="120px"
        width="120px"
        border-radius="50%"
        color="#dedede"
    />
  </div>
</template>

<script>


import notificationContentService from "@/service/notificationContentService";
import {handleErrorResponse} from "@/utils/utils";
import router from "@/router";

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean,
      default: true
    },
    journeyStatus: {
      type: Number,
      default: null
    },
    createdAt: {
      type: String,
      default: ''
    },
    photo: {
      type: String,
      default: ''
    },
    journeyId: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
    programName: {
      type: String,
      default: ''
    },
    generalPoint: {
      type: String,
      default: ''
    },
    onEndJourney: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      notificationSelectBoxOpen:false,
      notificationList:[
        {
          notificationId:"00000000000001",
          label:this.$t("create_new_notification"),
        }
      ],
      userSendList:[]
    }
  },
  created() {
    this.getNotificationList();
  },
  methods: {
    sendNotification(userIds,notificationDataId){
      notificationContentService.sendNotification(userIds,notificationDataId).then((res) => {
        if(res.data.data.failedNotifications.length > 0){
          this.$snackbar.add({
            text: this.$t("some_notifications_failed"),
            type: "failed"
          });
        }else{
          this.$snackbar.add({
            text: this.$t('selected_notification_assigned'),
            type: 'success'
          });
        }
      })
    },
    assignNotification(id){
      if(id==="00000000000001"){
        console.log("çalıştı")
        router.push({
          path: '/notification/new',
          query: {
            journeyId: this.journeyId,
            userIds: this.userId
          }
        });
      }else{
        this.userSendList.push(this.userId)
        this.sendNotification(this.userSendList,id);
        console.log(id +"is sent to"+ this.userId);
      }
    },
    getNotificationList() {
      notificationContentService.getNotificationContentList(true)
          .then(response => {
            this.notificationList.push(...response.data.data)
            console.log(this.notificationList);
          })
          .catch(error => {
            handleErrorResponse(error);
          });
    },
    closeNotification(){
      this.notificationSelectBoxOpen= false;
    },
    clickNotification(){
      this.notificationSelectBoxOpen= !this.notificationSelectBoxOpen;
    },
    formatDate(dateStr) {
      try {
        const date = new Date(dateStr);
        const options = {year: 'numeric', month: 'short', day: 'numeric'};
        return date.toLocaleDateString("en", options);
      } catch (e) {
        return '-';
      }
    },
  },
}

</script>

<style scoped>
.dropdown-wrapper{
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 200px;
  top: 80px;
  overflow-x:hidden;
  max-height:300px;
  overflow-y: scroll;
  border:#8c8c8c solid 1px;
  border-radius:8px;
  background-color: #FFFFFF;
  z-index: 3;
}
.dropdown-list {
  cursor: pointer;
  font-size: 12px;
  padding: 7px 15px;
  display: block;
  border-radius: 8px;
  margin: 5px;
}

.dropdown-list:hover {
  background-color: #F2F4F7;

}
.header-wrapper {
  position: relative;
  background-color: #F9FAFB;
  background-image: url("@/assets/images/companyHeader.svg");
  background-size: cover;
  padding: 40px;
  margin-bottom: 60px;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
h2 {
  font-family: euclid_semi_bold, sans-serif;
  font-size: 24px;
  color: #101828;
  margin: 0;
  padding: 0;
}
.company-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px
}
.company-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}
.company-status span {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #344054;
}
.action-row {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.action-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #98A2B3;
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 7px 10px;
  cursor: pointer;
  gap: 5px;
}
.action-button img {
  height: 16px;
  width: 16px;
}
.action-button:hover {
  background-color: #f5f5f5;
}

.action-button span {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #667085;
}

.company-stats {
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 12px;
}

.stat-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.stat-wrapper img {
  height: 16px;
  width: 16px;
}

.stat-wrapper span {
  font-size: 12px;
}

.stat-number {
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  color: #101828;
}

.company-image {
  height: 120px;
  width: 120px;
  border-radius: 50%;
  position: absolute;
  bottom: -60px;
  left: 40px;
}
</style>
